import React from 'react'
import { css } from 'aphrodite'
import themes from '../themes'

const Header = ({ label, renderBeforeDelimeter, theme }) => {
  const styles = themes[theme]
  return (
    <div>
      <div className={css(styles.sectionHeader)}>
        <span className={css(styles.sectionLabel)}>{label}</span>
        {renderBeforeDelimeter()}
      </div>
      <hr className={css(styles.delimeter)} />
    </div>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/FilterMenu/Section/Header/header.js